/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Document } from '../../core/models/Document';
import { Oas20Definitions } from '../../openapi/v2/models/Oas20Definitions';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SchemaDefinition } from '../../openapi/v2/models/Oas20SchemaDefinition';
import { DeleteSchemaDefinitionCommand } from './DeleteSchemaDefinitionCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends DeleteSchemaDefinitionCommand
 * @class
 */
export class DeleteSchemaDefinitionCommand_20 extends DeleteSchemaDefinitionCommand {
    public constructor(definitionName? : any) {
        if(((typeof definitionName === 'string') || definitionName === null)) {
            let __args = arguments;
            super(definitionName);
        } else if(definitionName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSchemaDefinitionCommand#doDeleteSchemaDefinition(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteSchemaDefinition(document : Document) : any {
        let doc20 : Oas20Document = <Oas20Document>document;
        let definitions : Oas20Definitions = doc20.definitions;
        if(this.isNullOrUndefined(definitions)) {
            return null;
        }
        let schemaDef : Oas20SchemaDefinition = definitions.removeDefinition(this._definitionName);
        return Library.writeNode(schemaDef);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSchemaDefinitionCommand#doRestoreSchemaDefinition(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} document
     * @param {*} oldDefinition
     */
    doRestoreSchemaDefinition(document : Document, oldDefinition : any) {
        let doc20 : Oas20Document = <Oas20Document>document;
        let definitions : Oas20Definitions = doc20.definitions;
        if(this.isNullOrUndefined(definitions)) {
            return;
        }
        let definition : Oas20SchemaDefinition = doc20.definitions.createSchemaDefinition(this._definitionName);
        Library.readNode(oldDefinition, definition);
        definitions.addDefinition(this._definitionName, definition);
    }
}
DeleteSchemaDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSchemaDefinitionCommand_20";
DeleteSchemaDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




